import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { DialogsService } from '../dialogs.service';
import { SharedModule } from '../../shared/shared.module';
import { PlanningArea } from '../../modules/admin/services/services.types';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';

@Component({
    selector: 'resources-select-area-dialog',
    templateUrl: './resources-select-area-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .resources-select-area-dialog-panel {

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SharedModule,
        TranslocoModule,
    ]
})
export class ResourcesSelectAreaDialog implements OnInit {

    control: FormControl = new FormControl<string>('', Validators.required);
    planningAreas: PlanningArea[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            planningAreas: PlanningArea[];
        },
        public dialogRef: MatDialogRef<ResourcesSelectAreaDialog>,
        private dialogsService: DialogsService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
    ) { }

    ngOnInit() {
    }

    accept() {
        const confirmDialog = this.openConfirmDialog();
        confirmDialog.afterClosed().subscribe((confirm) => {
            if (confirm === 'confirmed') {
                this.control.markAsTouched();
                if (this.control.valid) {
                    this.dialogRef.close(this.control.value);
                } else {
                    this.dialogsService.openErrorDialog({
                        message: this.transloco.translate('errorsInForm')
                    });
                }
            }
        });
    }

    closeDialog(area?: PlanningArea) {
        this.dialogRef.close(area);
    }

    private openConfirmDialog() {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: this.transloco.translate('selectAreaConfirm'),
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
